/* global SideDrawer */

if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector('.js-product-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.fetch = null;
      this.fetchedUrls = [];
      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);

      document.addEventListener('click', this.documentClickHandler);
      this.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      this.openCartDrawerLinks.forEach((link) => {
        console.log('opened slide cart')
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-quick-add').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              // Add event listener to new buttons
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });

              // Remove event listener from removed buttons
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });

          // Start observing changes to the DOM
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }

    /**
     * Bind a mouseenter event to a given quick add button if it's not already bound
     * @param {Element} button - The button element to bind the mouseenter event to.
     */
    bindQuickAddButtonMouseEnter(button) {
      if (!button.dataset.quickAddListenerAdded) {
        button.dataset.quickAddListenerAdded = 'true';
        button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      }
    }

    /**
     * Start the fetch on hover of a quick add button for perceived performance gains
     * @param {object} evt - Event object.
     */
    handleQuickAddButtonMouseEnter(evt) {
      if (!this.fetchedUrls.includes(evt.target.dataset.productUrl)) {
        this.fetch = {
          url: evt.target.dataset.productUrl,
          promise: fetch(evt.target.dataset.productUrl)
        };
                console.log('data fetch')
        this.fetchedUrls.push(evt.target.dataset.productUrl);
      }
    }

    /**
     * Handles 'click' events on success notification's 'View cart' link
     * @param {object} evt - Event object.
     */
    handleOpenCartClick(evt) {
      // Open the cart drawer if available on the page
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
        console.log('opened cart')
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    /**
     * Handles 'click' events on the document.
     * @param {object} evt - Event object.
     */
    handleDocumentClick(evt) {
      if (!evt.target.matches('.js-quick-add')) return;

      // Close the cart drawer if it's open
      if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.transitionDelay = '200ms';

        this.cartDrawer.close();

        // Wait a few ms for a more optimal ux/animation
        setTimeout(() => {
          this.backBtn.hidden = false;
          this.open(evt.target);
          if (overlay) overlay.style.transitionDelay = '';
        }, 200);
      } else {
        this.open(evt.target);
      }
    }

    /**
     * Handles 'on:variant:change' events on the Quick Add drawer.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      let url = this.productUrl;

      if (evt.detail.variant) {
        const separator = this.productUrl.split('?').length > 1 ? '&' : '?';
        url += `${separator}variant=${evt.detail.variant.id}`;
      }

      this.querySelectorAll('.js-prod-link').forEach((link) => {
        link.href = url;
      });
    }

    /**
     * Opens the drawer and fetches the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');
      console.log('cart open B');
      if (this.notification) this.notification.hidden = true;

      // If it's the same product as previously shown, there's no need to re-fetch the details.
      if (this.productUrl && this.productUrl === opener.dataset.productUrl) {
        super.open(opener);
        opener.removeAttribute('aria-disabled');
        return;
      }

      this.productUrl = opener.dataset.productUrl;
      this.content.innerHTML = '';
      console.log('content');
      console.log(opener.dataset);
      this.classList.add('is-loading');
      this.content.classList.add('drawer__content--out');
      this.footer.classList.add('drawer__footer--out');

      super.open(opener);

      if (!this.fetch || this.fetch.url !== opener.dataset.productUrl) {
        this.fetch = {
          url: opener.dataset.productUrl,
          promise: fetch(opener.dataset.productUrl)
        };
      }

      const response = await this.fetch.promise;
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        console.log('content2');
        console.log(tmpl);
                console.log('content3');
        this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');
        this.renderProduct(opener);
        console.log(opener);
      }

      this.fetch = null;

      opener.removeAttribute('aria-disabled');
    }

    /**
     * Closes the cart drawer.
     */
    close() {
      super.close(() => {
        this.backBtn.hidden = true;
      });
    }

    /**
     * Renders the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    renderProduct(opener) {
      // Replace instances of section id to prevent duplicates on the product page.
      const sectionId = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');

      // Prevent variant picker from updating the URL on change.
      const variantPicker = this.productEl.querySelector('variant-picker');

      if (variantPicker) {
        variantPicker.dataset.updateUrl = 'false';
        this.selectFirstVariant = variantPicker.dataset.selectFirstVariant === 'true';        
        
      }

      // Remove size chart modal and link (if they exist).
      const sizeChartModal = this.productEl.querySelector('[data-modal="size-chart"]');
      if (sizeChartModal) {
        sizeChartModal.remove();
      }


      this.updateContent();
      this.updateForm();           


      // Update the product media.
      const activeMedia = this.productEl.querySelector('.media-viewer__item.is-current-variant');
      if (activeMedia) this.updateMedia(activeMedia.dataset.mediaId);
        console.log('media update')
      if (opener.dataset.selectedColor && this.selectFirstVariant) {
        // Timeout to allow the VariantPicker to initialize
        setTimeout(this.setActiveVariant.bind(this, opener), 10);
      }      
    }

    /**
     * Set color variant to match the one selected in the card.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    setActiveVariant(opener) {
      const colorOptionBox = this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`);
      if (colorOptionBox) {
        this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`)
          .click();
      } else {
        const colorOptionDropdown = this.querySelector(
          `.custom-select__option[data-value="${opener.dataset.selectedColor}"]`
        );
        if (colorOptionDropdown) {
          const customSelect = colorOptionDropdown.closest('custom-select');
          customSelect.selectOption(colorOptionDropdown);
        }
      }
    }

    /**
     * Updates the product media.
     * @param {string} mediaId - Id of the media item to show.
     */
    updateMedia(mediaId) {
      const img = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!img) return;

      const src = img.src ? img.src.split('&width=')[0] : img.dataset.src.split('&width=')[0];
      const container = this.querySelector('.quick-add-info__media');
      const width = container.offsetWidth;
      const aspectRatio = img.width / img.height;

      container.innerHTML = `
        <img src="${src}&width=${width}" srcset="${src}&width=${width}, ${src}&width=${width * 2} 2x" width="${width * 2}" height="${(width * 2) / aspectRatio}" alt="${img.alt}">
      `;
    }

    /**
     * Builds the markup for the drawer content element.
     */
    updateContent() {
      // Extract only the variant labels (opt-label)
      const optionsHTML = this.getElementHtml('.product-options .opt-label');
      const weightElem = this.getElementHtml('.product-info__weight');
      const weightHTML = weightElem ? `<div class="product-info__weight text-sm mt-2">${weightElem}</div>` : '';

      this.content.innerHTML = `
        <div class="quick-add-info grid mb-8">
          <div class="quick-add-info__media${theme.settings.blendProductImages ? ' image-blend' : ''}"></div>
          <div class="quick-add-info__details">
            <div class="product-vendor-sku mb-2 text-sm">
              ${this.getElementHtml('.product-vendor-sku')}
            </div>
            <div class="product-title">
              <a class="h6 js-prod-link" href="${this.productUrl}">
                ${this.getElementHtml('.product-title')}
              </a>
            </div>
            ${weightHTML}
            <hr>
            <div class="product-price">
              ${this.getElementHtml('.product-price')}
            </div>
            <div class="text-theme-light text-sm mt-4">
              <a href="${this.productUrl}" class="link js-prod-link">
                ${theme.strings.viewDetails}
              </a>
            </div>
          </div>
        </div>

        <div class="product-options">
          <ul class="variants-list flex flex-wrap gap-2">
            ${optionsHTML}
          </ul>
        </div>

        <div class="product-backorder">
          ${this.getElementHtml('.product-backorder')}
        </div>
      `;

      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');
    }


    /**
     * Updates the Quick Add drawer form (buy buttons).
     */
updateForm() {
  this.form.innerHTML = ''; // Clear existing form

  const customerIsExempt = window.customerTags?.includes('exempt');

  // -----------------------------
  // 1. GET ALL ORIGINAL VARIANT LABELS
  // -----------------------------
  const variantInputs = Array.from(this.productEl.querySelectorAll('.opt-label'));

  // determine if variants have "exempt" or "retail"
  const hasTaggedVariants = variantInputs.some(label => {
    const title = label.querySelector('.variant-label')?.textContent?.toLowerCase() || '';
    return title.includes('exempt') || title.includes('retail');
  });

  // -----------------------------
  // 2. FILTERED VARIANTS (UNCHANGED)
  // -----------------------------
  let filteredVariants;
  if (hasTaggedVariants) {
    filteredVariants = variantInputs.filter(label => {
      const title = label.querySelector('.variant-label')?.textContent?.toLowerCase() || '';
      if (customerIsExempt) return title.includes('exempt');
      return title.includes('retail');
    });
  } else {
    filteredVariants = variantInputs;
  }

  // -----------------------------
  // 3. GROUP BY TEXT BEFORE SLASH
  // -----------------------------
  const grouped = {};
const first = filteredVariants[0];
const initAvailB = first ? first.getAttribute('availabile') || '' : '';
console.log('final init avail', initAvailB);

if(initAvailB == true){
  console.log("true");
} else{
  console.log("false");
  setTimeout(() => {
              const addToCartButtonInit = this.form.querySelector('.js-add-to-cart');
        addToCartButtonInit.disabled = false;  
  console.log('1 second delay complete');
}, 100);

  
}



  filteredVariants.forEach(label => {
    const thing = label.getAttribute('thing') || '';
    //add logic here for more robust option titling
    let group = '';

    if (thing.includes('/')) {
      group = thing.split('/')[0].trim();   // "White"
    }

    if (!grouped[group]) grouped[group] = [];
    grouped[group].push(label);
  });

  // -----------------------------
  // 4. RENDER GROUPED VARIANTS
  // -----------------------------
  let firstFound = false;

  Object.keys(grouped).forEach(group => {
    // Create title
    const titleEl = document.createElement('div');
    titleEl.className = 'variant-group-title';
    titleEl.textContent = group;
    if (group == 'Retail') {
            titleEl.className = 'variant-group-title retail hidden';

    }
        if (group == 'Exempt') {
            titleEl.className = 'variant-group-title exempt hidden';

    }
    if (group === 'Exempt' || group === 'Retail') {
    } else {

       this.form.appendChild(titleEl);
    }
    this.form.appendChild(titleEl);

    // Add labels under group
    grouped[group].forEach(label => {

      const clone = label.cloneNode(true);
      const input = clone.querySelector('input');

      if (!firstFound && input) {
        input.checked = true;
        clone.classList.add('selected');
        this.selectedVariantId = input.value;
        console.log('avail init ' + group );
        firstFound = true;
      }
        if (group == 'Exempt') {
        clone.classList.add('exempt');
      }
      if (group == 'Retail') {
        clone.classList.add('retail');
      }

      this.form.appendChild(clone);

    });
  });

  // -----------------------------
  // 5. ADD QUANTITY + ATC BUTTONS
  // -----------------------------
  const addToCartBlock = this.productEl.querySelector('.product-info__add-to-cart');
  if (addToCartBlock) this.form.appendChild(addToCartBlock.cloneNode(true));

  this.footer.classList.remove('quick-add__footer-message');
  this.footer.classList.remove('drawer__footer--out');

  // -----------------------------
  // 6. REBIND quantity inputs
  // -----------------------------
  this.form.querySelectorAll('quantity-input').forEach((el) => {
    if (typeof el.connectedCallback === 'function') el.connectedCallback();
  });

  // -----------------------------
  // 7. REBIND variant selection
  // -----------------------------
  this.form.querySelectorAll('.opt-btn').forEach((input) => {
    input.addEventListener('change', (e) => {
      const variantId = e.target.value;
      this.selectedVariantId = variantId;

      this.form.querySelectorAll('.opt-label').forEach(l => l.classList.remove('selected'));
      const selectedLabel = e.target.closest('.opt-label');
      if (selectedLabel) selectedLabel.classList.add('selected');

      const price = e.target.dataset.price;
      const priceEl = document.getElementById('price-display');
      if (priceEl) priceEl.textContent = price;

      const qtyText = selectedLabel?.querySelector('.variant-label')?.textContent?.trim() || '';
      const qty = parseInt(qtyText.replace(/\D/g, ''), 10);
      const priceNum = parseFloat(price.replace(/[^0-9.]/g, ''));
      const variantSku = e.target.dataset.sku;
      const skuDisplay = this.querySelector('#prod-sku');
      skuDisplay.textContent = variantSku;
       const variantAvailability = e.target.dataset.availability;
      console.log('availability' + variantAvailability);

      if (variantAvailability == 'true'){
    console.log('enable');
            const addToCartButton = this.form.querySelector('.js-add-to-cart');
        addToCartButton.disabled = false;
      } else {
        const addToCartButton = this.form.querySelector('.js-add-to-cart');
        addToCartButton.disabled = true;
        console.log('disable');
      }
      //config OUT OF STOCK
      const pricePerRoundEl = this.querySelector('#price-per-round-display');

      if (!pricePerRoundEl) return;

      if (!isNaN(qty) && qty > 0 && !isNaN(priceNum)) {
        const perRound = (priceNum / qty).toFixed(2);
        pricePerRoundEl.textContent = `$${perRound} / round`;
        pricePerRoundEl.style.display = 'inline';
      } else {
        pricePerRoundEl.style.display = 'none';
      }
    });
  });

  // ensure initial selected styling
  const checkedInput = this.form.querySelector('.opt-btn:checked');
  if (checkedInput) checkedInput.closest('.opt-label')?.classList.add('selected');
  const initAvail = checkedInput.getAttribute('availabile');
  console.log('initavail ' + initAvail );
  // -----------------------------
  // 8. REBIND Add To Cart
  // -----------------------------
  const addToCartBtn = this.form.querySelector('.js-add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async () => {
      if (!this.selectedVariantId) return;

      const quantityInput = this.form.querySelector('input[name="quantity"]');
      const quantity = parseInt(quantityInput?.value || 1);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.selectedVariantId, quantity }),
      });

      if (res.ok) {
        this.addedToCart();
        if (this.cartDrawer?.refresh) await this.cartDrawer.refresh(true);
        setTimeout(() => this.cartDrawer.open(), 200);
      }
    });
  }

  // -----------------------------
  // 9. Init Shopify Payment Buttons
  // -----------------------------
  if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();

  // -----------------------------
  // 10. INITIAL per-round calc
  // -----------------------------
  const priceEl = document.getElementById('price-display');
  const priceText = priceEl ? priceEl.textContent.trim() : null;
  const priceNum = parseFloat(priceText?.replace(/[^0-9.]/g, ''));

  const selectedLabel = this.form.querySelector('.opt-label.selected');
  const qtyText = selectedLabel?.querySelector('.variant-label')?.textContent?.trim() || '';
  const qty = parseInt(qtyText.replace(/\D/g, ''), 10);

  const pricePerRoundEl = this.querySelector('#price-per-round-display');
  if (!pricePerRoundEl) return;

  if (!isNaN(qty) && qty > 0 && !isNaN(priceNum)) {
    const perRound = (priceNum / qty).toFixed(2);
    pricePerRoundEl.textContent = `$${perRound} / round`;
    pricePerRoundEl.style.display = 'inline';
  } else {
    pricePerRoundEl.style.display = 'none';
  }
}




    /**
     * Gets the innerHTML of elements within the product element.
     * @param {string} selector - CSS selector for the element.
     * @param {...*} additionalSelectors - Additional CSS selectors for elements.
     * @returns {?string}
     */
    getElementHtml(selector, ...additionalSelectors) {
      const selectors = [selector].concat(additionalSelectors);
      let html = '';
      selectors.forEach((sel) => {
        const els = this.productEl.querySelectorAll(sel);
        Array.from(els).forEach((el) => {
          html += el.innerHTML;
        });
      });
      return html;
    }

    /**
     * Shows an "Added to cart" message in the drawer.
     */
    addedToCart() {
      if (this.notification) {
        setTimeout(() => {
          this.notification.hidden = false;
        }, 300);

        setTimeout(() => {
          this.notification.hidden = true;
        }, this.notification.dataset.visibleFor);
      }
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}
